import axios from 'axios';
import PrestadorTabla from '../types/PrestadorTabla';

async function InsertarPrestador(PrestadorNuevo: PrestadorTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_prestador"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "prestador": [
                {
                    "cuit": PrestadorNuevo.cuit,
                    "razonsocial": PrestadorNuevo.razonsocial,
                    "nombrecomercial": PrestadorNuevo.nombrecomercial,
                    "domicilio": PrestadorNuevo.domicilio,
                    "telefono": PrestadorNuevo.telefono,
                    "whatsapp": PrestadorNuevo.whatsapp,
                    "email": PrestadorNuevo.email,
                    "sitioweb": PrestadorNuevo.sitioweb,
                    "instagram": PrestadorNuevo.instagram,
                    "facebook": PrestadorNuevo.facebook,
                    "youtube": PrestadorNuevo.youtube,
                    "tiktok": PrestadorNuevo.tiktok,
                    "linkedin": PrestadorNuevo.linkedin,
                    "gpslat": PrestadorNuevo.gpslat,
                    "gpslon": PrestadorNuevo.gpslon,
                    "idrubro": PrestadorNuevo.idrubro,
                    "habilitado": PrestadorNuevo.habilitado,
                    "idpais": PrestadorNuevo.idpais,
                    "idprovincia": PrestadorNuevo.idprovincia,
                    "idlocalidad": PrestadorNuevo.idlocalidad,
                    "logo_big": PrestadorNuevo.logo_big,
                    "logo_small": PrestadorNuevo.logo_small,
                    "observaciones": PrestadorNuevo.observaciones,
                }
            ]
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarPrestador;